import { Amplify } from 'aws-amplify';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import {
  REACT_APP_COGNITO_POOL_CLIENT_ID,
  REACT_APP_COGNITO_POOL_ID,
  REACT_APP_TENANT_SERVICE_URL,
  alert,
} from '~/utils';

class AmplifyAuth {
  constructor() {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: REACT_APP_COGNITO_POOL_ID || '',
          userPoolClientId: REACT_APP_COGNITO_POOL_CLIENT_ID || '',
        },
      },
    });
    cognitoUserPoolsTokenProvider.setKeyValueStorage(
      new CookieStorage({ domain: 'primecontrol.com.br', secure: true }),
    );
  }

  // logged
  verifyUser = async (): Promise<boolean> => {
    try {
      const user = await getCurrentUser();
      return true;
    } catch (error) {
      return false;
    }
  };

  getUsername = async (): Promise<{ username: string }> => {
    const { username } = await getCurrentUser();

    return { username };
  };

  logout = async (): Promise<boolean> => {
    try {
      await signOut({ global: true });
      return true;
    } catch (error) {
      return false;
    }
  };

  getToken = async (): Promise<string> => {
    try {
      const session = await fetchAuthSession(); // Fetch the authentication session
      return session.tokens?.accessToken.toString() || '';
    } catch (e) {
      return '';
    }
  };

  getIdToken = async (): Promise<string> => {
    try {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() || '';
    } catch (e) {
      return '';
    }
  };

  getTenantId = (): string => {
    try {
      // Busca o cookie tenant_id
      const cookies = document.cookie.split(';');
      const tenantCookie = cookies.find(cookie => cookie.trim().startsWith('tenant_id='));

      if (tenantCookie) {
        const tenantId = tenantCookie.split('=')[1];
        return decodeURIComponent(tenantId);
      }

      console.warn('Cookie tenant_id não encontrado');
      return 'default-tenant';
    } catch (error) {
      console.error('Erro ao obter tenantId dos cookies:', error);
      return 'default-tenant';
    }
  };

  isUserAdmin = async (tenantId: string): Promise<boolean> => {
    try {
      const token = await this.getToken();

      if (!token) {
        console.error('Token não disponível');
        return false;
      }

      const url = `${REACT_APP_TENANT_SERVICE_URL}/tenant/${tenantId}/level-permission`;

      const response = await axios.get(url, {
        headers: {
          authorization: token,
          'x-tenant-id': tenantId,
        },
        timeout: 5000,
      });

      // Verifica se o nível de permissão é 1 (admin)
      return response.data === 1;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 403) {
          console.warn('Usuário não possui permissão de admin');
          return false;
        }
        if (error.response?.status === 503) {
          console.error('Serviço de tenant indisponível');
          return false;
        }
      }
      console.error('Erro ao verificar permissões de admin:', error);
      return false;
    }
  };

  getUserGroups = async (): Promise<string[]> => {
    try {
      const token = await this.getIdToken();

      if (!token) return [];

      const decodedToken: any = jwtDecode(token);
      return decodedToken['cognito:groups'] || [];
    } catch (error) {
      console.error('Erro ao obter grupos do usuário:', error);
      return [];
    }
  };
}

export default AmplifyAuth;
